function handleErr(setMessage, consoleMsg) {
    setMessage({ type: 'error', text: 'Não foi possível completar a requisição.' });
    console.log(consoleMsg);
}

function formatPhonePt(value) {
  if (!value) return "";

  const digits = value.replace(/\D/g, "");

  const phone = digits.startsWith("351")
    ? digits.slice(3)
    : digits;

  return `+351 ${phone.slice(0, 1)}${phone.slice(1, 3)} ${phone.slice(3, 6)} ${phone.slice(6, 9)}`.trim();
}

function isValidVimeoEmbed(url) {
  try {
    const parsed = new URL(url);

    return (
      parsed.protocol === 'https:' &&
      parsed.hostname === 'player.vimeo.com'
    );
  } catch (err) {
    return false;
  }
}

const paginationPageSize = () => 5;

export { handleErr, formatPhonePt, paginationPageSize, isValidVimeoEmbed as isValidVideoEmbed };